import React from 'react'
import RowSet from '../components/primitives/grid/row-set'
import StyledButton from '../components/primitives/styled-button'
import Container from '../components/primitives/grid/container'
// import BlocksFacilitiesByBodyArea from '../components/blocks/facilities-by-body-area'

const NotFoundPage = (): React.ReactElement => (
    <div
        css={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '50vh',
        }}
    >
        <Container>
            <RowSet breakpoints={{ dt: { between: 48 } }}>
                <h1 className="h1" css={{ width: '100%', textAlign: 'center' }}>
                    404
                </h1>
                <h2 className="h3" css={{ width: '100%', textAlign: 'center' }}>
                    Sie haben sich verlaufen.
                    <br />
                    Hier geht es zur Startseite:
                </h2>
                <div
                    css={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <StyledButton to="/" arrowLeft>
                        Zurück
                    </StyledButton>
                </div>
            </RowSet>
        </Container>
    </div>
)

export default NotFoundPage
